
export class QuantityDiscountCalculator
{
    public static Calc(discounts: { quantity: number; discountPercent: number; }[], quantity: number): { discountMultiplier: number; discountPercent: number; }
    {
        // Szuka zniżki na podstawie ilości
        const applicableDiscount = discounts
            .filter(discount => quantity >= discount.quantity) // Filtrujemy zniżki, które mają ilość mniejszą lub równą zamówieniu
            .sort((a, b) => b.quantity - a.quantity) // Sortujemy zniżki malejąco wg ilości
            .shift(); // Wybieramy największą ilość, która pasuje

        // Jeśli nie ma pasującej zniżki, zwrócimy 1 (brak zniżki)
        if (!applicableDiscount) return ({ discountMultiplier: 1, discountPercent: 0 });

        // Zwróć wartość jako mnożnik, czyli 1 - (znizka / 100)
        const discountMultiplier = 1 - (applicableDiscount.discountPercent / 100);

        return ({ discountMultiplier, discountPercent: applicableDiscount.discountPercent });
    }
}
